<div class="modal-header">
  <h3 class="mb-0">{{ title }}</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="exemptVendorTypeForm">
    <div class="row g-3">
      <div class="col-md-7">
        <div class="form-group mb-0">
          <label for="type" class="form-label">Vendor type</label>
          <input
            id="type"
            type="text"
            class="form-control"
            formControlName="type"
            placeholder="e.g. Insurance company, Financial services"
          />
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group mb-0">
          <label for="isTaxIdRequired" class="form-label">
            Require tax ID?
          </label>
          <select
            id="isTaxIdRequired"
            class="form-select"
            formControlName="isTaxIdRequired"
          >
            <option [ngValue]="false">No</option>
            <option [ngValue]="true">Yes</option>
          </select>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="cancel()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>
